// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ix-3";
export var downloadButton = "_ix-4";
export var fileContainer = "_ix-9 _ix-7";
export var fileContainerBase = "_ix-7";
export var fileContainerFixedHeight = "_ix-8 _ix-7";
export var fileInfo = "_ix-5";
export var fileInfoWidthRestricted = "_ix-6";
export var fileType = "_ix-1";
export var fileTypeName = "_ix-2";
export var image = "_ix-0";
export var link = "_ix-b";
export var overflowEllipsis = "_ix-a";